const TESTING_TEACHER_TYPE = {
  field: {
    master: 1,
    main: 2,
    sub: 3,
    assistant: 4,
    info: 5,
    reserve: 6,
  },
  value: [1, 2, 3, 4, 5, 6],
  name: {
    1: '총감독위원',
    2: '시험감독관(정)',
    3: '시험감독관(부)',
    4: '보조감독관',
    5: '통제위원',
    6: '관리위원',
  },
};

const TESTING_TEACHER_STATUS = {
  field: {
    join: 1,
    joined: 2,
    completed: 6,
    redraw: 7,
    delete: 8,
    deleted: 9,
  },
  value: [
    1, // join
    2, // modify
    6, // completed
    7, // redraw
    8, // delete
    9, // deleted
  ],
  used: [1, 2, 6],
  unused: [7, 8, 9],
  name: {
    1: '신규작성',
    2: '변경요청',
    6: '승인확정',
    7: '승인보류',
    8: '삭제요청',
    9: '승인거절'
  },
};


module.exports = {
  TESTING_TEACHER_TYPE,
  TESTING_TEACHER_STATUS,
};